<script setup lang="ts">
    import { useAppStore } from '#imports';
    import { useAuthStore } from '#imports';
    
    /* Store variables */
    const { txt } = storeToRefs(useAppStore());
    const authStore = useAuthStore()
    const { isDemo, isLoggedIn } = storeToRefs(authStore);
    const { loadSession } = authStore;

    await loadSession();
</script>

<template>
    <div class="pr-3">
        <div v-if="!isDemo && !isLoggedIn" class="d-flex">
            <v-btn
                class="mx-3 emboss"
                color="secondary"
                to="/login"
                nuxt>
                {{ txt.logIn }}
            </v-btn>
            <v-btn
                color="primary"
                variant="flat"
                to="/register"
                nuxt>
                {{ txt.signUp }}
            </v-btn>
        </div>
    </div>
</template>